<template>
  <div :class="bem()">
    <LinkDirectional
      :class="bem('back-link')"
      text="back"
      to="/owners"
      theme="black"
    />

    <div
      :class="bem('category')"
    >
      <BaseCopy
        size="h3"
        :class="bem('category-header')"
      >
        {{ product.title }}
      </BaseCopy>
      <ul :class="bem('articles')">
        <OwnersGuideArticle
          v-for="article in articles"
          :key="article.id"
          :article="article"
          :class="bem('article')"
        />
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  getOwnersGuideArticles,
  type OwnersGuideArticlesResponse
} from '~/gql/ownersGuide.gql'

type OwnersGuideProduct = {
  id: string
  baseSku: string
  title: string
  sku: string
}

interface Props {
  products: OwnersGuideProduct[]
}

const props = defineProps<Props>()

const bem = useBEM('OwnersManualDetail')

const route = useRouter().currentRoute.value
const { $sentry, runWithContext } = useNuxtApp()
const { getTitle, getDescription } = useMetaHelper()

const product = props.products.find((product) =>
  product.sku.startsWith(`${route.params.product}`)
)

if (!product) {
  navigateTo('/owners')
}

const { data, error } = await useDatoQuery<OwnersGuideArticlesResponse>({
  query: getOwnersGuideArticles,
  variables: {
    productID: product!.id,
    offset: 0,
    limit: 100
  }
})

if (error.value) {
  $sentry.captureException(error)
  createError({
    statusCode: error.value.statusCode,
    statusMessage: error.value.statusMessage,
  })
}

const articles = computed(() => {
  return data.value?.allOwnersGuideArticles || []
})


runWithContext(() => useHead({
  title: getTitle(`SunGod ${product.title} Owners Guide`),
  meta: [
    ...getDescription(
      `
        Instructions for the use and care of
        your SunGod ${product.title}.
      `
    ),
    {
      hid: 'og:title',
      property: 'og:title',
      content: getTitle(`SunGod ${product.title} Owners Guide`),
    },
  ],
}))
</script>

<style lang="postcss">
.OwnersManualDetail__category {
  @apply my-md;
}
</style>
